/*
  Bundle-Inhalt auf der Produktseite (snippets/bundle-inhalt.liquid).

  Shopify-eigene Bundles haben ihre Bestandteile nicht in Liquid, sondern nur in der Storefront API.
  Dieses Skript holt die Bestandteile der gerade gewaehlten Variante (ohne Token, gleiche Domain) und baut
  daraus die Liste: Menge, Name, gewaehlte Sorte und Bild. Aendert sich das Bundle im Admin, stimmt die
  Anzeige sofort. Bei Bundles mit Auswahl (z. B. Geschmack) laedt die Liste beim Wechsel der Auswahl neu,
  die alte Liste bleibt so lange stehen. Abgefragt wird pro Variante, weil solche Bundles schnell
  hunderte Varianten haben.
  Bewusst ohne Links zu den Einzelprodukten, damit niemand die Bundle-Seite verlaesst.
  Ausverkaufte Bestandteile werden ausgegraut und mit Badge markiert, darunter steht ein Hinweis.

  Rueckfall: Scheitert die Abfrage oder hat die gewaehlte Variante keine Bestandteile, wird das gepflegte
  Bild (custom.bundle_inhalt_bild) gezeigt. Gibt es auch das nicht, verschwindet der Block komplett.

  Simple-Bundles-Produkte laufen ueber das zweite Element <bundle-auswahl> weiter unten in dieser Datei.
*/
(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('bundle-inhalt')) return;

  var API_VERSION = '2026-07';
  var GID_PREFIX = 'gid://shopify/ProductVariant/';
  var QUERY =
    'query BundleInhalt($id: ID!) {' +
    ' node(id: $id) { ... on ProductVariant { id' +
    '  components(first: 20) { nodes { quantity' +
    '   productVariant { id title availableForSale' +
    '    image { url(transform: {maxWidth: 160, maxHeight: 160}) }' +
    '    product { title featuredImage { url(transform: {maxWidth: 160, maxHeight: 160}) } }' +
    '   } } }' +
    ' } }' +
    '}';

  var requests = {};

  /* Eine Abfrage pro Variante, Ergebnis: Liste der Bestandteile (leer, wenn es kein Bundle ist) */
  function loadComponents(variantGid) {
    if (!requests[variantGid]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      requests[variantGid] = fetch(root + 'api/' + API_VERSION + '/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: QUERY, variables: { id: variantGid } })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Storefront API ' + response.status);
          return response.json();
        })
        .then(function (json) {
          if (!json || !json.data) throw new Error('Keine Daten');
          var node = json.data.node;
          return (node && node.components && node.components.nodes) || [];
        })
        .catch(function (error) {
          delete requests[variantGid];
          throw error;
        });
    }
    return requests[variantGid];
  }

  function createElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  /*
    Feste Reihenfolge, damit die Zeilen beim Wechsel der Auswahl nicht springen: zuerst die Produkte
    mit Auswahl in der Reihenfolge der Auswahlfelder (Shopify nennt die Option "Produktname (Option)"),
    danach der Rest nach Name.
  */
  function sortComponents(components, optionNames) {
    function rank(component) {
      var title = component.productVariant.product.title;
      for (var i = 0; i < optionNames.length; i++) {
        if (optionNames[i].indexOf(title) === 0) return i;
      }
      return optionNames.length;
    }
    return components.slice().sort(function (a, b) {
      var diff = rank(a) - rank(b);
      if (diff !== 0) return diff;
      return a.productVariant.product.title.localeCompare(b.productVariant.product.title);
    });
  }

  class BundleInhalt extends HTMLElement {}

  BundleInhalt.prototype.connectedCallback = function () {
    if (this._ready) return;
    this._ready = true;

    this.list = this.querySelector('[data-bundle-list]');
    this.count = this.querySelector('[data-bundle-count]');
    this.note = this.querySelector('[data-bundle-note]');
    this.fallback = this.querySelector('[data-bundle-fallback]');

    var configElement = this.querySelector('[data-bundle-config]');
    try {
      this.config = JSON.parse(configElement.textContent);
    } catch (error) {
      this.showFallback();
      return;
    }
    this.variantGid = GID_PREFIX + this.config.variantId;

    var self = this;
    this._onVariantChange = function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      /* Nur auf das Formular dieses Produkts reagieren (das Ereignis kommt auch von anderen Formularen) */
      var form = event.target;
      if (!form || !form.getAttribute || form.getAttribute('id') !== self.config.formId) return;
      self.variantGid = GID_PREFIX + variant.id;
      self.load();
    };
    document.addEventListener('variant:change', this._onVariantChange);

    this.load();
  };

  BundleInhalt.prototype.disconnectedCallback = function () {
    if (this._onVariantChange) document.removeEventListener('variant:change', this._onVariantChange);
    this._ready = false;
  };

  BundleInhalt.prototype.load = function () {
    var self = this;
    var variantGid = this.variantGid;
    loadComponents(variantGid)
      .then(function (components) {
        /* Antwort verwerfen, wenn inzwischen eine andere Variante gewaehlt wurde */
        if (variantGid !== self.variantGid) return;
        self.update(components);
      })
      .catch(function () {
        if (variantGid !== self.variantGid) return;
        self.showFallback();
      });
  };

  BundleInhalt.prototype.update = function (components) {
    components = (components || []).filter(function (component) {
      return component.productVariant && component.productVariant.product && component.quantity > 0;
    });
    if (!components.length) {
      this.showFallback();
      return;
    }
    this.render(sortComponents(components, this.config.optionNames || []));
  };

  BundleInhalt.prototype.render = function (components) {
    var config = this.config;
    var texts = config.texts || {};
    var parts = 0;
    var soldOutCount = 0;
    var fragment = document.createDocumentFragment();

    components.forEach(function (component) {
      var variant = component.productVariant;
      parts += component.quantity;

      var soldOut = !variant.availableForSale;
      if (soldOut) soldOutCount += 1;

      var item = createElement('li', 'bundle-inhalt__item');
      var row = createElement('div', 'bundle-inhalt__row' + (soldOut ? ' bundle-inhalt__row--soldout' : ''));

      var media = createElement('span', 'bundle-inhalt__media');
      var image = variant.image || variant.product.featuredImage;
      if (image && image.url) {
        var img = document.createElement('img');
        img.src = image.url;
        img.alt = '';
        img.width = 64;
        img.height = 64;
        img.decoding = 'async';
        media.appendChild(img);
      }
      row.appendChild(media);

      var text = createElement('span', 'bundle-inhalt__text');
      var name = createElement('span', 'bundle-inhalt__name');
      name.appendChild(createElement('span', 'bundle-inhalt__qty', component.quantity + ' ×'));
      name.appendChild(document.createTextNode(' ' + variant.product.title));
      text.appendChild(name);

      if (variant.title && variant.title !== 'Default Title') {
        text.appendChild(createElement('span', 'bundle-inhalt__meta', variant.title));
      }
      if (soldOut && texts.soldOut) {
        text.appendChild(createElement('span', 'bundle-inhalt__badge', texts.soldOut));
      }
      row.appendChild(text);

      item.appendChild(row);
      fragment.appendChild(item);
    });

    this.list.textContent = '';
    this.list.appendChild(fragment);
    this.list.hidden = false;
    this.list.removeAttribute('aria-busy');
    if (this.fallback) this.fallback.hidden = true;

    if (this.count) {
      var label = components.length === 1 ? texts.productsOne : (texts.products || '').replace('[n]', components.length);
      if (parts !== components.length && texts.parts) label += ' · ' + texts.parts.replace('[n]', parts);
      this.count.textContent = label || '';
      this.count.hidden = !label;
    }

    if (this.note) {
      var note = soldOutCount > 0 && texts.soldOutNote
        ? texts.soldOutNote.replace('[n]', soldOutCount).replace('[m]', components.length)
        : '';
      this.note.textContent = note;
      this.note.hidden = !note;
    }

    var wrapper = this.closest('.product-info__bundle-inhalt');
    if (wrapper) wrapper.hidden = false;
    this.setAttribute('data-state', 'ready');
  };

  BundleInhalt.prototype.showFallback = function () {
    if (this.list) {
      this.list.hidden = true;
      this.list.removeAttribute('aria-busy');
    }
    if (this.count) this.count.hidden = true;
    if (this.note) this.note.hidden = true;

    if (this.fallback) {
      this.fallback.hidden = false;
      this.setAttribute('data-state', 'fallback');
      return;
    }

    /* Weder Bestandteile noch Bild: Block samt Ueberschrift ausblenden, damit keine Luecke bleibt */
    this.setAttribute('data-state', 'empty');
    var wrapper = this.closest('.product-info__bundle-inhalt');
    if (wrapper) wrapper.hidden = true;
  };

  window.customElements.define('bundle-inhalt', BundleInhalt);

  /*
    ---------- Simple Bundles (snippets/bundle-inhalt-auswahl.liquid) ----------
    Die Liste kommt fertig aus Liquid. Dieses Element verbindet die Auswahl in der Liste mit den
    Auswahlfeldern der App (#simple-bundles-io-options im Produktformular):
    - Die App-Felder bleiben die Quelle fuer die Bestellung, sie werden nur per CSS ausgeblendet.
    - Aendert der Kunde hier die Sorte, wird der Wert ins App-Feld geschrieben und ein change-Ereignis
      ausgeloest, damit die App ihre versteckten Felder aktualisiert.
    - Was die App als ausverkauft sperrt, wird hier ausgegraut. Ist ein Platz komplett ausverkauft,
      ist das Bundle nicht bestellbar: Hinweis unter der Liste, Button gesperrt.
    Findet das Element die App-Felder nicht, zeigt es wieder die Felder der App (Rueckfall).
  */
  var ACTIVE_CLASS = 'bundle-auswahl-active';
  var UNAVAILABLE_CLASS = 'is-bundle-unavailable';
  var CONNECT_TIMEOUT = 8000;

  function availableValues(select) {
    var values = [];
    Array.prototype.forEach.call(select.options, function (option) {
      if (option.value !== '' && !option.disabled) values.push(option.value);
    });
    return values;
  }

  function notifyChange(select) {
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  class BundleAuswahl extends HTMLElement {}

  BundleAuswahl.prototype.connectedCallback = function () {
    if (this._ready) return;
    this._ready = true;

    var self = this;
    try {
      this.config = JSON.parse(this.querySelector('[data-bundle-config]').textContent);
    } catch (error) {
      this.useFallback();
      return;
    }

    this.note = this.querySelector('[data-bundle-note]');
    this.slots = Array.prototype.map.call(this.querySelectorAll('[data-bundle-slot]'), function (item) {
      return {
        name: item.getAttribute('data-option-name'),
        fixedValue: item.getAttribute('data-option-value'),
        row: item.querySelector('[data-bundle-row]'),
        badge: item.querySelector('[data-bundle-badge]'),
        select: item.querySelector('[data-bundle-select]'),
        image: item.querySelector('[data-bundle-image]'),
        touched: false
      };
    });

    this.slots.forEach(function (slot) {
      if (!slot.select) return;
      slot.select.addEventListener('change', function () {
        slot.touched = true;
        self.updateImage(slot);
        if (self.connected) {
          self.pushToApp(slot);
          self.refresh();
        }
      });
    });

    if (this.connect()) return;

    /* Die App setzt ihre Felder erst nach dem Laden ins Formular: warten, bis sie da sind */
    this._waiter = new MutationObserver(function () {
      if (self.connect()) self.stopWaiting();
    });
    this._waiter.observe(document.body, { childList: true, subtree: true });
    this._timeout = setTimeout(function () {
      self.stopWaiting();
      if (!self.connected) self.useFallback();
    }, CONNECT_TIMEOUT);
  };

  BundleAuswahl.prototype.disconnectedCallback = function () {
    this.stopWaiting();
    if (this._appObserver) this._appObserver.disconnect();
    if (this._refreshTimer) clearTimeout(this._refreshTimer);
    this._ready = false;
    this.connected = false;
  };

  BundleAuswahl.prototype.stopWaiting = function () {
    if (this._waiter) this._waiter.disconnect();
    if (this._timeout) clearTimeout(this._timeout);
    this._waiter = null;
    this._timeout = null;
  };

  BundleAuswahl.prototype.findAppSelect = function (name) {
    var container = document.getElementById('simple-bundles-io-options');
    if (!container) return null;
    var wanted = 'properties[' + name + ']';
    var selects = container.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      if (selects[i].getAttribute('name') === wanted) return selects[i];
    }
    return null;
  };

  BundleAuswahl.prototype.connect = function () {
    if (this.connected) return true;
    var container = document.getElementById('simple-bundles-io-options');
    if (!container) return false;

    var self = this;
    var complete = this.slots.every(function (slot) {
      return !!self.findAppSelect(slot.name);
    });
    if (!complete) return false;

    this.connected = true;
    this.slots.forEach(function (slot) {
      if (!slot.select) return;
      if (slot.touched) self.pushToApp(slot);
      else self.pullFromApp(slot);
    });

    /* Sperrt oder tauscht die App spaeter Optionen, zieht die Liste nach */
    this._appObserver = new MutationObserver(function () {
      self.scheduleRefresh();
    });
    this._appObserver.observe(container.parentElement || container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled']
    });

    document.documentElement.classList.add(ACTIVE_CLASS);
    this.setAttribute('data-state', 'ready');
    this.refresh();
    return true;
  };

  BundleAuswahl.prototype.scheduleRefresh = function () {
    var self = this;
    if (this._refreshTimer) clearTimeout(this._refreshTimer);
    this._refreshTimer = setTimeout(function () {
      self._refreshTimer = null;
      if (self.connected) self.refresh();
    }, 50);
  };

  BundleAuswahl.prototype.pushToApp = function (slot) {
    var appSelect = this.findAppSelect(slot.name);
    if (!appSelect || appSelect.value === slot.select.value) return;
    appSelect.value = slot.select.value;
    if (appSelect.value !== slot.select.value) return;
    notifyChange(appSelect);
  };

  BundleAuswahl.prototype.pullFromApp = function (slot) {
    var appSelect = this.findAppSelect(slot.name);
    if (!appSelect || appSelect.value === '' || appSelect.value === slot.select.value) return;
    slot.select.value = appSelect.value;
    this.updateImage(slot);
  };

  BundleAuswahl.prototype.updateImage = function (slot) {
    if (!slot.image || !slot.select) return;
    var option = slot.select.options[slot.select.selectedIndex];
    var url = option && option.getAttribute('data-image');
    if (url && slot.image.getAttribute('src') !== url) slot.image.setAttribute('src', url);
  };

  BundleAuswahl.prototype.refresh = function () {
    var self = this;
    var texts = this.config.texts || {};
    var soldOut = 0;

    this.slots.forEach(function (slot) {
      var appSelect = self.findAppSelect(slot.name);
      if (!appSelect) return;

      var available = availableValues(appSelect);
      var slotAvailable;

      if (slot.select) {
        Array.prototype.forEach.call(slot.select.options, function (option) {
          var ok = available.indexOf(option.value) !== -1;
          var label = option.getAttribute('data-label') || option.value;
          var text = ok ? label : label + (texts.soldOutSuffix || '');
          if (option.disabled === ok) option.disabled = !ok;
          if (option.textContent !== text) option.textContent = text;
        });
        slotAvailable = available.length > 0;
        if (slotAvailable && available.indexOf(slot.select.value) === -1) {
          slot.select.value = available[0];
          self.updateImage(slot);
        }
        if (slot.select.disabled === slotAvailable) slot.select.disabled = !slotAvailable;
        if (slotAvailable) self.pushToApp(slot);
      } else {
        slotAvailable = slot.fixedValue ? available.indexOf(slot.fixedValue) !== -1 : available.length > 0;
        if (slotAvailable && appSelect.value === '') {
          appSelect.value = slot.fixedValue || available[0];
          notifyChange(appSelect);
        }
      }

      slot.row.classList.toggle('bundle-inhalt__row--soldout', !slotAvailable);
      if (slot.badge) slot.badge.hidden = slotAvailable;
      if (!slotAvailable) soldOut += 1;
    });

    if (this.note) {
      var note = soldOut > 0 && texts.soldOutNote
        ? texts.soldOutNote.replace('[n]', soldOut).replace('[m]', this.slots.length)
        : '';
      this.note.textContent = note;
      this.note.hidden = !note;
    }

    this.setOrderable(soldOut === 0);
  };

  /* Bundle nicht bestellbar: Button sperren und beschriften, "Auf Lager"-Zeile per CSS-Klasse tauschen */
  BundleAuswahl.prototype.setOrderable = function (orderable) {
    var root = this.closest('.product-info');
    if (root) root.classList.toggle(UNAVAILABLE_CLASS, !orderable);

    var container = document.getElementById('simple-bundles-io-options');
    var form = container && container.closest('form');
    var button = form && form.querySelector('button[type="submit"]');
    if (!button) return;

    var locked = button.hasAttribute('data-bundle-locked');
    if (!orderable && !locked) {
      button.setAttribute('data-bundle-locked', '');
      this._buttonWasDisabled = button.disabled;
      button.disabled = true;
      var label = this.findButtonLabel(button);
      var text = this.config.texts && this.config.texts.soldOut;
      if (label && text) {
        this._buttonLabel = label;
        this._buttonText = label.nodeValue;
        label.nodeValue = ' ' + text + ' ';
      }
    } else if (orderable && locked) {
      button.removeAttribute('data-bundle-locked');
      button.disabled = !!this._buttonWasDisabled;
      if (this._buttonLabel) this._buttonLabel.nodeValue = this._buttonText;
      this._buttonLabel = null;
    }
  };

  /* Letzter Textknoten mit Inhalt im Button (davor steht das Icon) */
  BundleAuswahl.prototype.findButtonLabel = function (button) {
    var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
    var found = null;
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim() !== '') found = node;
    }
    return found;
  };

  BundleAuswahl.prototype.useFallback = function () {
    document.documentElement.classList.remove(ACTIVE_CLASS);
    this.setAttribute('data-state', 'fallback');
  };

  window.customElements.define('bundle-auswahl', BundleAuswahl);
})();
